import { FormattedMessage } from 'react-intl';
import * as PropTypes from 'prop-types';

import { PageWrapper } from 'modules/layout';

import Form from '../../containers/Info/UpdateInfoForm';

const InfoPage = ({ id, categoryId }) => (
    <PageWrapper header={<FormattedMessage id="info.update.title" />}>
        {<Form id={id} categoryId={categoryId} />}
    </PageWrapper>
);

InfoPage.propTypes = {
    id: PropTypes.string.isRequired,
    categoryId: PropTypes.string.isRequired,
};

export default InfoPage;
